import { Section } from '../../models/menu.interfaces';

export const ProfileSectionMocks: Section = {
  id: 'profile-2',
  title: 'My Profile',
  items: [
    {
      id: 'personal-details',
      link: {
        label: 'Personal Details',
        url: '/my-profile/personal-details'
      },
      selected: false
    },
    {
      id: 'preferences',
      link: {
        label: 'Preferences',
        url: '/my-profile/preferences'
      },
      selected: false
    },
    {
      id: 'loyalty-programs',
      link: {
        label: 'Other Loyalty Programs',
        url: '/my-profile/loyalty-programs'
      },
      selected: false
    },
    {
      id: 'companions',
      link: {
        label: 'Companions',
        url: '/my-profile/companions'
      },
      selected: false
    },
    {
      id: 'saved-searches',
      link: {
        label: 'Saved Searches',
        url: '/my-profile/saved-searches'
      },
      selected: false
    },
    {
      id: 'certificates',
      link: {
        label: 'Certificates, eCredits & Vouchers',
        url: '/my-profile/certificates'
      },
      selected: false
    },
    {
      id: 'payment-methods',
      link: {
        label: 'Payment Methods',
        url: '/my-profile/payment-methods'
      },
      selected: false
    },
    {
      id: 'security-settings',
      link: {
        label: 'Password & Security Settings',
        url: '/my-profile/security-settings'
      },
      selected: false
    }
  ],
  url: '',
  opened: false
};
